import {useTable, useColumns} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {permissionColumns} from './columns/columns'
import {InOutLoading} from '../components/loading/InOutLoading'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {InOutPagination} from '../components/pagination/InOutPagination'
import InOutVisibilityModal from '../components/modal/InOutVisibilityModal'
import {useIntl} from 'react-intl'

const InOutTable = ({printRef, show, setShow}) => {
  const intl = useIntl()

  const permissions = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = permissions
  const columns = permissionColumns

  const {
    getTableProps,
    getTableBodyProps,
    headers,
    rows,
    prepareRow,
    state: {hiddenColumns},
    setHiddenColumns,
  } = useTable(
    {
      columns,
      data,
    },
    useColumns
  )

  return (
    <KTCardBody className='py-4'>
      {show && (
        <InOutVisibilityModal
          setShow={setShow}
          hiddenColumns={hiddenColumns}
          headers={headers}
          columns={columns}
          setHiddenColumns={setHiddenColumns}
        />
      )}
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          ref={printRef}
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((header) => {
                switch (header.isVisible) {
                  case false:
                    return null
                  case true:
                    return <CustomHeaderColumn key={header.id} column={header} />
                  default:
                    return null
                }
              })}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({id: 'NO.MATCHING.FOUND'})}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <InOutPagination />
      {isLoading && <InOutLoading />}
    </KTCardBody>
  )
}

export {InOutTable}
